exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reference-report-page[data-v-0aef7db6]{background:#f5f7fb}.page-toolbar[data-v-0aef7db6]{border-radius:6px 6px 0 0}.report-row[data-v-0aef7db6]:hover{background:#f8fbff}.summary-row[data-v-0aef7db6]{background:#f5f5f5!important}.summary-row td[data-v-0aef7db6]{font-weight:700}@media (max-width:960px){.reference-report-page[data-v-0aef7db6]{overflow-x:hidden}}", ""]);

// exports
